import { baseApi } from "utils/axios/baseApi";
import { GET_APPT_INVOICE_DETAIL, GET_APPT_INVOICE_LIST } from "config/apiPaths";

const appointmentInvoices = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // get client appointment balance
    getApptInvoicesList: builder.query({
      query: (payload) => ({
        method: "PATCH",
        url: GET_APPT_INVOICE_LIST,
        data: payload
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['ApptInvoicesList']
    }),
    getApptInvoiceDetail: builder.query({
      query: (id) => ({
        method: "GET",
        url: `${GET_APPT_INVOICE_DETAIL}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['ApptInvoiceDetail']
    }),
  })
})

export const {
  useGetApptInvoicesListQuery,
  useGetApptInvoiceDetailQuery,
} = appointmentInvoices